import React from 'react'
import cx from 'classnames'
import { Link, l } from '@manychat/manyui'

import { KnowledgeBaseLink } from 'common/core/components/SupportLinks'
import { SupportedHelpArticleLanguage, useHelpArticleLink } from 'common/hooks/useHelpArticleLink'

import cm from '../common.module.css'

const FBRecurringNotificationsDeprecatedNotification = () => {
  const helpArticleLink = useHelpArticleLink(KnowledgeBaseLink.FB_MARKETING_MESSAGES, [
    SupportedHelpArticleLanguage.EN,
  ])

  return (
    <>
      <span className="m-r-xxs">
        {l.translate(
          `Meta has replaced Recurring Notifications with Marketing Messages on Messenger in your country.`,
        )}
      </span>
      <Link href={helpArticleLink} target="_blank" className={cx('d-inline-block', cm.link)}>
        {l.translate('Read more')}
      </Link>
    </>
  )
}

export default FBRecurringNotificationsDeprecatedNotification
